module.exports = __webpack_public_path__ + "img/main_index_bg.fd9b81f6.jpg";